import { ComponentType, memo } from 'react';

import { IUseBroadcastChannelReturn } from './types';
import { useBroadcastChannel } from './useBroadcastChannel';

export function withBroadcasterChannel<P>(
  Component: ComponentType<P & IUseBroadcastChannelReturn>,
  channelName: string,
  isActive: boolean = true,
) {
  function ComponentWithBroadcasterChannel(props: P) {
    const { isChannelActive, broadcastChannel, sendChannelMessage, subscribe, closeChannel } =
      useBroadcastChannel({
        name: channelName,
        isActive,
      });

    return (
      <Component
        {...props}
        isChannelActive={isChannelActive}
        broadcastChannel={broadcastChannel}
        sendChannelMessage={sendChannelMessage}
        subscribe={subscribe}
        closeChannel={closeChannel}
      />
    );
  }

  return memo(ComponentWithBroadcasterChannel);
}
